import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';

const styles = {
  container: ({ palette }) => ({
    padding: 3,
    backgroundColor: palette.colors.lightPale,
    borderRadius: 4,
    border: `1px solid ${palette.colors.darkPale}`,
    marginTop: 3,
  }),
};

export const EmptyListOverlay = ({ isFiltered = false, itemsName, customStyles = null, ...props }) => {
  return (
    <Stack spacing={2} sx={[styles.container, customStyles]} {...props}>
      <Typography variant="subtitle1-bold" component="p">
        {isFiltered ? 'No Results Found' : `No ${itemsName} Yet`}
      </Typography>

      <Typography variant="subtitle1" component="p">
        {isFiltered
          ? `No ${itemsName.toLowerCase()} match your current search criteria. Try adjusting your filters or search term.`
          : `There are no ${itemsName.toLowerCase()} to display at the moment.`}
      </Typography>
    </Stack>
  );
};

EmptyListOverlay.propTypes = {
  isFiltered: PropTypes.bool,
  itemsName: PropTypes.string.isRequired,
  customStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};
